import {
  OrganizationPillarTypes,
  PILLAR_ID,
  POLICY_NUMBER_ID,
} from '../insurance.constants';

const BASE_URL = `/insurance/${PILLAR_ID}/engagement/contracts`;
const BASE_LIFE_URL = `${BASE_URL}/individualrisk`;
const BASE_HEALTH_URL = `${BASE_URL}/individualrisk`;
const RISK_URL_WITH_ID = `${BASE_URL}/${POLICY_NUMBER_ID}`;
const LIFE_URL_WITH_ID = `${BASE_LIFE_URL}/${POLICY_NUMBER_ID}`;
const HEALTH_URL_WITH_ID = `${BASE_HEALTH_URL}/${POLICY_NUMBER_ID}`;
export const NAV_G_VALUE_URL = '/open/shared/nav/baseamount';

interface IURL {
  LIFE: string;
  HEALTH: string;
  RISK_INSURANCE: string;
}

const changeUrls: IURL = {
  LIFE: `${LIFE_URL_WITH_ID}/change`,
  HEALTH: `${HEALTH_URL_WITH_ID}/change`,
  RISK_INSURANCE: `${RISK_URL_WITH_ID}/change`,
};

const cancelUrls: IURL = {
  LIFE: `${LIFE_URL_WITH_ID}/cancel`,
  HEALTH: `${HEALTH_URL_WITH_ID}/cancel`,
  RISK_INSURANCE: `${RISK_URL_WITH_ID}/cancel`,
};

const cancelCwpUrls: IURL = {
  RISK_INSURANCE: `${RISK_URL_WITH_ID}/cancellation`,
  LIFE: `${LIFE_URL_WITH_ID}/cancellation`,
  HEALTH: `${HEALTH_URL_WITH_ID}/cancellation`,
};

const manualCancelUrls: IURL = {
  LIFE: `${LIFE_URL_WITH_ID}/cancel/manual`,
  HEALTH: `${HEALTH_URL_WITH_ID}/cancel/manual`,
  RISK_INSURANCE: `${RISK_URL_WITH_ID}/cancel/manual`,
};

const detailsUrls: Omit<IURL, 'HEALTH'> = {
  LIFE: `${LIFE_URL_WITH_ID}/withDetails?details=true`,
  RISK_INSURANCE: `${RISK_URL_WITH_ID}/withDetails?details=true`,
};

const changePriceUrls: IURL = {
  LIFE: `${LIFE_URL_WITH_ID}/price`,
  HEALTH: `${HEALTH_URL_WITH_ID}/price`,
  RISK_INSURANCE: `${RISK_URL_WITH_ID}/price`,
};

const organizationPillarUrlPaths = {
  [OrganizationPillarTypes.LIFE]: 'life',
  [OrganizationPillarTypes.HEALTH]: 'health',
  [OrganizationPillarTypes.RISK_INSURANCE]: 'risk',
};

export const getChangeUrlByPillar = (
  organizationPillar: OrganizationPillarTypes,
): string =>
  changeUrls[organizationPillar].replace(
    PILLAR_ID,
    organizationPillarUrlPaths[organizationPillar],
  );

export const getCancelUrlByPillar = (
  organizationPillar: OrganizationPillarTypes,
): string =>
  cancelUrls[organizationPillar].replace(
    PILLAR_ID,
    organizationPillarUrlPaths[organizationPillar],
  );

export const getCancelCWPUrlByPillar = (
  organizationPillar: OrganizationPillarTypes,
): string =>
  cancelCwpUrls[organizationPillar].replace(
    PILLAR_ID,
    organizationPillarUrlPaths[organizationPillar],
  );

export const getManualCancelUrlByPillar = (
  organizationPillar: OrganizationPillarTypes,
): string =>
  manualCancelUrls[organizationPillar].replace(
    PILLAR_ID,
    organizationPillarUrlPaths[organizationPillar],
  );

export const getDetailsUrl = (
  policyNumber: string,
  organizationPillar: Exclude<OrganizationPillarTypes, 'HEALTH'>,
): string => {
  return detailsUrls[organizationPillar]
    .replace(PILLAR_ID, organizationPillarUrlPaths[organizationPillar])
    .replace(POLICY_NUMBER_ID, policyNumber);
};

export const getNewPriceUrl = (
  policyNumber: string,
  organizationPillar: OrganizationPillarTypes,
): string => {
  return changePriceUrls[organizationPillar]
    .replace(PILLAR_ID, organizationPillarUrlPaths[organizationPillar])
    .replace(POLICY_NUMBER_ID, policyNumber);
};

export const getReregistrationPriceUrl = (
  policyNumber: string,
  organizationPillar: OrganizationPillarTypes,
): string => {
  return `${RISK_URL_WITH_ID}/registration/price`
    .replace(PILLAR_ID, organizationPillarUrlPaths[organizationPillar])
    .replace(POLICY_NUMBER_ID, policyNumber);
};

export const getReregistrationAcceptUrl = (
  policyNumber: string,
  organizationPillar: OrganizationPillarTypes,
): string => {
  return `${RISK_URL_WITH_ID}/registration/accept`
    .replace(PILLAR_ID, organizationPillarUrlPaths[organizationPillar])
    .replace(POLICY_NUMBER_ID, policyNumber);
};
